import { EmployeeFinanceDetails } from './EmployeeFinanceDetails';
import { OnboardVrifications } from './OnboardVrifications';
import { FileToUpload } from './filetoupload';

export class OnboardEmployeeFinanceDetails {
  EmpId: number;
   UAN: string;
   OptedNationalPensionScheme: boolean;
   NpsPran: string;
   BankName: string; 
   BankAccount: string;
   BankAccountName: string;
   IFSCCode: string;
  Branch: string;
  CancelledChequeFile: FileToUpload;
  CancelledChequeFilePath: string;
  CancelledChequeFileName: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  PF_StartDate: Date;
  IsMigratedOnH1: boolean;
  IsEligibleForPF: boolean;
  SSN: string;
  Elig_Med: number;
  Elig_InC: number;
  Elig_NnP: number;
  Billability: boolean;
  CostCenter: string;
  empFinanceDetails: EmployeeFinanceDetails[];
  onboardVrifications: OnboardVrifications = new OnboardVrifications();
  NoOfAccounts: number;
}
